export const GET_SURVEY = 'GET_SURVEY';
export const GET_SURVEYS = 'GET_SURVEYS';
export const LOADING_SURVEY = 'LOADING_SURVEY';
export const LOADING_SURVEYS = 'LOADING_SURVEYS';
export const SAVE_LOADER_SURVEY = 'SAVE_LOADER_SURVEY'